import { apiGet } from './apiClient';

export interface ChartDataset {
  label: string;
  data: number[];
  backgroundColor?: string | string[];
  borderColor?: string | string[];
  borderWidth?: number;
}

export interface ChartData {
  labels: string[];
  datasets: ChartDataset[];
}

export interface NewsFeedItem {
  id: string;
  title: string;
  subtitle: string;
  chart_type: 'bar' | 'line' | 'pie' | 'doughnut';
  chart_data: ChartData;
  tags: string[];
  date: string;
  team: string;
  insights: string[];
  is_active: boolean;
  order_index: number;
  created_at: string;
  updated_at: string;
}

export const getNewsFeedItems = async (): Promise<NewsFeedItem[]> => {
  try {
    const payload = await apiGet<{ data: NewsFeedItem[] }>('/news-feed');
    return payload?.data || [];
  } catch (error) {
    console.error('Error in getNewsFeedItems:', error);
    return [];
  }
};

export const getNewsFeedItemById = async (id: string): Promise<NewsFeedItem | null> => {
  try {
    const payload = await apiGet<{ data: NewsFeedItem | null }>(`/news-feed/${encodeURIComponent(id)}`);
    return payload?.data || null;
  } catch (error) {
    console.error('Error in getNewsFeedItemById:', error);
    return null;
  }
};





